/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.applySearchParams();
      this.updateFinalSale();
      this.sizeChart = this.querySelector('.size-chart-link');
      if(this.sizeChart){
        this.sizeChart.addEventListener('click', this.handleSizeFitClick.bind(this));
      }

      if(this.productForm.classList.contains('js-outfit-product-form')){
        document.querySelectorAll('#size-fit .chart-images').forEach((e, i) => {if(i != 0){e.classList.add('hidden')}});
      }
      this.runABTest();

      this.setAttribute('loaded', '');
    }

    runABTest(){
      
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      
      evt.target.closest('.option-selector').querySelector('.label').classList.remove('label--contains-error');
      if(evt.target.closest('.option-selector').querySelector('.error'))
        evt.target.closest('.option-selector').querySelector('.error').classList.add('hidden');
      
      if(evt.target.closest('.option-selector').classList.contains('open')){
        evt.target.closest('.option-selector').classList.remove('open');
        const allBtn = evt.target.closest('variant-picker').querySelectorAll('.mobile-option-expander-btn');
        allBtn.forEach(btn => {
          if(window.innerWidth < 768){
            btn.querySelectorAll('span')[0].innerText = this.variant.option1;
          }
          btn.classList.remove('open');
        });
      }

      const optionName = evt.target.closest('.option-selector').dataset.option;
      if(optionName == 'Size'){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'pdp_click',
          // parameter:'select_size_click',
          eventParameter:{
            event_trigger_type: 'select_size_click',
            event_trigger_value: evt.target.value
          },
          custom_event_label: 'select_size_click',
          custom_event_value: evt.target.value
          // eventModel: {
          //   event_category: 'Product Page',
          //   event_label: 'select_size_click',
          //   value: evt.target.value
          // }
        });
      }
      if(optionName == 'Color'){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'pdp_click',
          // parameter:'select_color_click',
          eventParameter:{
            event_trigger_type: 'select_color_click',
            event_trigger_value: evt.target.value
          },
          custom_event_label: 'select_color_click',
          custom_event_value: evt.target.value
          // eventModel: {
          //   event_category: 'Product Page',
          //   event_label: 'select_color_click',
          //   value: evt.target.value
          // }
        });
      }

      if(this.section.classList.contains('cart-upsell-product') ){
        let variantId = '';
        if(!this.variant){
          variantId = this.data.variants.find(v => v.options[0] == this.selectedOptions[0]);
        }else{
          variantId = this.variant;
        }

        if(variantId != '' && variantId != undefined && this){
          (async () => {
            try {
              const baseUrl = window.location.origin;
              const htmlResponse = await this.renderSection(baseUrl + this.dataset.url + '?sections=product-block&id='+variantId.id);
              const innerHTML = JSON.parse(htmlResponse)['product-block'];
              const htmlDoc = new DOMParser().parseFromString(innerHTML, 'text/html');
              const productBlock = htmlDoc.querySelector('.product-block');
              const currentImage = productBlock.querySelector('.product-block__image[data-media-id="'+variantId.featured_media.id+'"]');
        
              if (productBlock && productBlock.dataset.productId) {
                this.closest('.product-block').querySelector('.product-block__image').innerHTML = currentImage.innerHTML;
              }
            } catch (error) {
              console.error(`Error loading product :`, error);
            }
          })();
        }
      }
      
      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability(evt);
      if(!this.productForm.classList.contains('js-outfit-product-form')){
        this.updatePrice();
      }
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);
      this.updateBIS();

      if(this.productForm.classList.contains('js-outfit-product-form')){
        const productId = evt.target.closest('.outfit-product').dataset.productId;
        if(document.querySelector(`#size-fit [data-product-chart="chart-${productId}"]`).innerHTML != ''){
          document.querySelectorAll('#size-fit .chart-images').forEach(e => e.classList.add('hidden'));
          document.querySelector(`#size-fit [data-product-chart="chart-${productId}"]`).classList.remove('hidden');
        }
        if (this.variant) {
          this.productForm.querySelector(`#id-${productId}`).value = this.variant.id;
        }
      }
      
      if(!this.variant){
        if (!this.section) return;
        if(this.section.querySelector('.product-info-block')){
          this.section.querySelector('.product-info-block').hidden = true;
        }
      }else{
        if(this.section.querySelector('.product-info-block')){
          this.section.querySelector('.product-info-block').hidden = false;
        }
      }

      if(this.productForm.classList.contains('js-outfit-product-form')){
        const productId = evt.target.closest('.outfit-product').dataset.productId;
        if(this.section.querySelector(`.media-gallery#outfit-product-${productId}`) && evt.target.closest('.option-selector').dataset.option == 'Color'){
          this.currentProductMedia = this.section.querySelector(`.media-gallery#outfit-product-${productId}`);
          this.section.querySelectorAll('media-gallery').forEach(el => el.classList.add('hidden'));
          this.currentProductMedia.classList.remove('hidden');
        }
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            product: productId,
            form: this.productForm,
            variant: this.variant,
            allVariants: this.data.variants,
            selectedOptions: this.selectedOptions
          }
        }));
        return;
      }
      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions
        }
      }));
    }

    renderSection = async (sectionId) => {
      try {
        const response = await fetch(sectionId);
        if (response.ok) {
          return await response.text();
        } else {
          throw new Error('Failed to load section');
        }
      } catch (error) {
        console.error(error);
      }
    };

    handleSizeFitClick(evt){
      evt.preventDefault();
      const targetId = evt.target.getAttribute('href'); // Get target ID
      const targetElement = this.section.querySelector(targetId);
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'pdp_click',
        // parameter:'whats_my_size_click',
        eventParameter:{
          event_trigger_type: 'whats_my_size_click',
          event_trigger_value: evt.target.closest('product-form').dataset.productTitle
        },
        custom_event_label: 'whats_my_size_click',
        custom_event_value: evt.target.closest('product-form').dataset.productTitle
        // eventModel: {
        //   event_category: 'Product Page',
        //   event_label: 'whats_my_size_click',
        //   value: evt.target.closest('product-form').dataset.productTitle
        // }
      });
      if(!targetElement.querySelector('.disclosure[open]')){
        targetElement.querySelector('.disclosure__title').dispatchEvent(new Event('click', { bubbles: true }));
      }
    }

    updateBIS(){
      if(this.variant){
        if(!this.variant.available){
          this.section.querySelector('.buy-buttons-row').classList.add('hidden');
          if(this.section.querySelector('product-ship-message'))
            this.section.querySelector('product-ship-message').classList.add('hidden');
          this.section.querySelector('.notify-back-in-stock-container').classList.remove('hidden');
        }else{
          this.section.querySelector('.buy-buttons-row').classList.remove('hidden');
          if(this.section.querySelector('product-ship-message'))
            this.section.querySelector('product-ship-message').classList.remove('hidden');
           if(this.section.querySelector('.notify-back-in-stock-container'))
          this.section.querySelector('.notify-back-in-stock-container').classList.add('hidden');

        }
      }
    }

    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;
      
      if (this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.classList.remove('is-error');
      this.addBtn.setAttribute('aria-disabled', !variantAvailable);

      if(this.addBtn.querySelector('.add-to-cart-text')){
        this.addBtn.querySelector('.add-to-cart-text').textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
        return;
      }
      
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      // el.disabled = !available;
      el.disabled = false;
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability(evt) {
      if (this.dataset.availability === 'off') return;
      const { availabilityMode } = this.dataset; // 'down' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMode === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""]):not(.custom-select__option-exclude)');
          
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            if(option.closest('.option-selector').dataset.option != 'Color'){
              VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
            }
          });
        });
        if(this.optionSelectors.length > 1){
          this.updateColorAvailability(evt);
        }
      }
    }

    updateColorAvailability(evt){
      let assignFirst = false;
      let optionIndex = 0;

      const isOptionSelectorEvent = evt?.target?.closest('.option-selector');
      if (isOptionSelectorEvent && +isOptionSelectorEvent.dataset.optionIndex > 1) {
        assignFirst = true;
        optionIndex = +isOptionSelectorEvent.dataset.optionIndex - 1;
      }

      if (this.firstTime === true) {
        assignFirst = true;
        optionIndex = 1;
      }

      if (!assignFirst) return;

      const matchedVariants = this.data.variants.filter(v => {
        const opts = this.selectedOptions;

        // color disabled fix on 
             opts.forEach((o, i) => {
            if (o == null){
              opts[i] = this.data.variants[0][`option${i+1}`]
            }
          })

        if (opts.length === 3) {
          return opts[2] != null
            ? opts[1] === v.options[1] && opts[2] === v.options[2]
            : opts[1] === v.options[1];
        }
        if (opts.length === 2) {
          return opts[1] === v.options[1];
        }
        return false;
      });
      // console.log(matchedVariants);

      this.optionSelectors.forEach((selector, selectorIndex) => {
        if (optionIndex <= selectorIndex) return;

        const isDropdown = selector.dataset.selectorType === 'dropdown';
        const options = selector.querySelectorAll('.js-option:not([data-value=""]):not(.custom-select__option-exclude)');

        options.forEach((option, index) => {
          const optionValue = isDropdown ? option.dataset.value : option.value;
          const isAvailable = matchedVariants.some(v => v.options[selectorIndex] === optionValue && v.available);
          if(selectorIndex == 0){
            if(option.closest('.opt-btn-container')){
              option.closest('.opt-btn-container').querySelector('.custom-select__btn').disabled = !isAvailable;
            }
            VariantPicker.updateOptionAvailability(option, true, isAvailable);
          }
        });
      });
    }

    updateFinalSale(){
      if(!this.querySelector('.final-sale-swatches')){
        return;
      }
      this.finalSaleContainer = this.querySelector('.final-sale-swatches');
      this.finalSaleColors = this.querySelectorAll('.final-sale-swatch');
      const btnsContainer = this.finalSaleContainer.querySelector('.option-selector__btns');
      if(this.finalSaleColors && this.finalSaleColors.length > 0){
        this.finalSaleContainer.classList.remove('hidden');
        this.finalSaleColors.forEach(swatch => {
          console.log(swatch);
          if(btnsContainer.querySelector('.swatch-slider') != undefined){
            const swatchDiv = swatch.closest('.swatch-wrapper');
            swatch.classList.remove('hidden');
            btnsContainer.querySelector('.swatch-slider').appendChild(swatchDiv);
          }else{
            swatch.classList.remove('hidden');
            btnsContainer.appendChild(swatch);
          }
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const otherOption = selector.querySelector('.js-option-text');

      if(otherOption){
        otherOption.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      }

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      if(evt.target.classList.contains('final-sale-swatch')){
        colorText.textContent = '';
        selector.querySelector('.final-sale-swatches .js-color-text').textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
        return;
      }else{
        if(evt.target.closest('.option-selector').dataset.option == 'Color' && selector.querySelector('.final-sale-swatches .js-color-text')){
          selector.querySelector('.final-sale-swatches .js-color-text').textContent = '';
        }
      }
      
      if(evt.target.tagName == 'SELECT'){
        // colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      }else{
        colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice(container) {
      this.price = this.price || this.section.querySelector('.product-info__price .price');
      this.discountLabel = this.discountLabel || this.section.querySelector(`.product-info__price .product-label-container`);
      if(container){
        this.price = this.section.querySelector(`${container} .product-info__price .price`);
        this.discountLabel = this.section.querySelector(`${container} .product-info__price .product-label-container`);
      }
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {

        variant = this.data.variants.find(v => v.available);
        /* remove code for lowest price replace it with default first available variant. */
        // variant = this.data.variants[0];
        // for (let i = 1; i < this.data.variants.length; i += 1) {
        //   if (this.data.variants[i].price < variant.price) variant = this.data.variants[i];
        // }
      }

      if(!this.getSelectedVariant() || this.selectedOptions.indexOf(null) > -1){
        return;
      }

      if (variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        if(this.price.querySelector('.extra-price')){
          this.price.querySelector('.extra-price').remove();
        }

        let memberDiscountPrice= variant.price - (variant.price*10/100);
        if(this.section.querySelector('.product-membership-widget')){
          if(this.section.querySelector('.product-membership-widget').classList.contains('existing-membership')){
            memberDiscountPrice= variant.price*20/100;
            if(this.section.querySelector(`.single-product-membership-widget`).classList.contains('hidden')){
              this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }else{
              this.section.querySelector(`.single-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }
          }else{
            if(this.section.querySelector(`.single-product-membership-widget`) && !this.section.querySelector(`.single-product-membership-widget`).classList.contains('hidden')){
              this.section.querySelector(`.single-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }
            if(this.section.querySelector(`.pack-product-membership-widget`) && !this.section.querySelector(`.pack-product-membership-widget`).classList.contains('hidden')){
              memberDiscountPrice= variant.price*20/100;
              this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }
          }
        }


        // Update current price and original price if on sale.
        // priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        if(document.querySelector('body').classList.contains('template-subscription-product')){
          priceCurrentEl.innerHTML = `${this.data.formatted[variant.id].price}/Month `;
        }else{
          priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        }
        if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          unitPriceEl.hidden = false;
        } else if (unitPriceEl) {
          unitPriceEl.hidden = true;
        }

        this.price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        this.price.classList.toggle('price--sold-out', !variant.available && !this.preSelection);

        if(this.discountLabel){
          if(this.discountLabel.querySelector('.product-label--sale span')){
            if(variant.compare_at_price > variant.price){
              const cal1 = 1.0*(variant.price/variant.compare_at_price);
              const cal2 = (1.0 - cal1);
              const discountAmount = (1.0 - cal1)*100;
              this.discountLabel.querySelector('.product-label--sale span').classList.remove('hidden');
              this.discountLabel.querySelector('.product-label--sale span').innerText = `${Math.round(discountAmount)}% Off`;
            }else{
              this.discountLabel.querySelector('.product-label--sale span').classList.add('hidden');
            }
          }
        }
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }

      if(!container){
        this.updatePrice('.desktop-price-container');
        this.updatePrice('.price-container:not(.desktop-price-container)');
      }
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      window.history.replaceState({ }, '', url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }

    /**
     * Apply search parameters.
     */
    applySearchParams() {
      const searchParams = new URLSearchParams(window.location.search);

      Array.from(searchParams.keys()).forEach((key) => {
        const value = searchParams.get(key);
        const optionSelectors = Array.from(this.optionSelectors);
        const matchingOptionSelector = optionSelectors.find((x) => x.dataset.option === key);
        if (!matchingOptionSelector) return;

        if (matchingOptionSelector.dataset.selectorType === 'dropdown') {
          const colorOptionDropdown = matchingOptionSelector.querySelector(`.custom-select__option[data-value="${value}"]`);
          if (colorOptionDropdown) {
            const customSelect = colorOptionDropdown.closest('custom-select');
            customSelect.selectOption(colorOptionDropdown);
          }
        } else {
          const matchingInput = matchingOptionSelector.querySelector(`input[value="${value}"]`);
          if (matchingInput) {
            const matchingOptionValue = matchingOptionSelector.querySelector('.option-selector__label-value');
            if (matchingOptionValue) {
              matchingOptionSelector.querySelector('.option-selector__label-value').textContent = value;
            }
            matchingInput.checked = true;
            matchingInput.dispatchEvent(
              new CustomEvent('change', { bubbles: true, cancelable: false })
            );
          }
        }
      });
    }
  }

  customElements.define('variant-picker', VariantPicker);

  if (!customElements.get('variant-picker-build')){
    class VariantPickerBuild extends VariantPicker {
      constructor() {
        super();
        this.section = this.closest('.js-product');
        this.productForm = this.section.querySelector('.js-product-form');
        this.packInputContainer = this.productForm.querySelector('.pack-inputs');
        this.packTypeInput = this.productForm.querySelector('[name="__pack-type"]');
        this.discountMessage = this.productForm.querySelector('.build-pack-discount-container');
        this.colorSwiperContainer = this.querySelector('.build-pack-color-container');
        this.colorCountContainer = this.querySelector('.pack-count');
        this.totalQuantity = 0;
        this.numberSelectors = this.querySelectorAll('.custom-number-selector');
        this.variantData = this.getVariantData();
        this.validateQtyBuild = true;

        this.addEventListener('change', this.handleVariantChange.bind(this));
        this.numberSelectors.forEach(el => {
          el.addEventListener('click', this.handleNumberColorSelection.bind(this));
        });
        this.querySelectorAll('.custom-number-selector-native').forEach(el => {
          el.addEventListener('change', this.handleNumberColorSelection.bind(this));
        });
        this.colorSwiperContainer.querySelectorAll('.btn-scroll').forEach(el => {
          el.addEventListener('click', this.handleColorScroll.bind(this));
        });

        // this.totalColors = this.querySelectorAll('.build-pack-color-container .option-selector__btns .opt-btn-container');
        // if(this.totalColors && this.totalColors.length == 1){
        //   this.udpateDiscountMessage();
        // }
      }

      handleOptionBtnVisibility(){
        const swiper = document.querySelector(".build-pack-color-swiper");
        const scrollContainer = swiper.querySelector(".option-selector__btns");
        if(scrollContainer.scrollWidth > scrollContainer.clientWidth){
          swiper.classList.remove('no-buttons');
        }else{
          swiper.classList.add('no-buttons');
        }
      }
      
      handleOptionScrollBtn(){
        const swiper = document.querySelector(".build-pack-color-swiper");
        const scrollContainer = swiper.querySelector(".option-selector__btns");
        if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
          swiper.classList.add("scrollable");
        } else {
          swiper.classList.remove("scrollable");
        }
      }

      handleNumberColorSelection(evt){
        const colorElement = evt.target.closest('.opt-btn-container').querySelector('.opt-btn');
        colorElement.checked = true;
        colorElement.dispatchEvent(new Event('change', { bubbles: true }));
      }

      handleVariantChange(evt){
        this.selectedOptions = this.getSelectedOptions();
        this.variant = this.getSelectedVariant();

        if(evt.target.classList.contains('custom-number-selector')){
          this.udpateDiscountMessage();
          this.updatePrice();
        }else{
          super.handleVariantChange(evt);
          const optSize = evt.target.closest('.build-pack-options').querySelectorAll('[data-option="Color"] .option-selector__btns .opt-btn-container');
          
          if(evt.target.closest('.option-selector').dataset.option != 'Color' && optSize.length > 1){
            this.resetColorNumbers();
          }
        }
        this.selectVariants();
        this.updateColorSelectionLabel(evt);
      }

      handleColorScroll(evt){
        this.swiperArea = this.colorSwiperContainer.querySelector('.build-pack-color-swiper .option-selector__btns');
        if(evt.target.classList.contains('btn-left')){
          this.swiperArea.scrollLeft += -50;
        }
        if(evt.target.classList.contains('btn-right')){
          this.swiperArea.scrollLeft += 50;
        }
      }

      updateColorSelectionLabel(evt){
        const selection = this.getSelectedColorNumbers();
        
        if(!this.expanded || (evt && evt.target.classList.contains('custom-select-container'))){
          this.expanded = false;
        }

        const colorText = this.querySelector('.js-color-text');
        if (!colorText) return;

        if (!this.expanded) {
          const firstTwo = selection.slice(0, 2).map(s => s.quantity <= 1 ? s.color : `${s.quantity}x ${s.color}`);
          const remaining = selection.slice(2);
          const remainingTotal = remaining.reduce((sum, s) => sum + s.quantity, 0);

          colorText.innerHTML = remainingTotal > 0
            ? `${firstTwo.join(', ')}, <a href="#" id="toggleMore">+${remaining.length} more</a>`
            : firstTwo.join(', ');
        } else {
          const all = selection.map(s => s.quantity <= 1 ? s.color : `${s.quantity}x ${s.color}`);
          colorText.innerHTML = `${all.join(', ')}`;
        }

        // Add click listener
        document.getElementById('toggleMore')?.addEventListener('click', (e) => {
          e.preventDefault();
          this.expanded = !this.expanded;
          this.updateColorSelectionLabel();
        });

        /*const selectionText = selection.map(s => s.quantity <= 1 ? s.color : `${s.quantity}x ${s.color}`);

        if(selectionText.length > 0){
          const selector = evt.target.closest('.option-selector');
          if (selector.dataset.selectorType === 'dropdown') return;
  
          const colorText = selector.querySelector('.js-color-text');
          if (!colorText) return;
  
          colorText.textContent = selectionText.join(', ');
        }*/
      }

      selectVariants(){
        this.selectedColorNumber = this.getSelectedColorNumbers();
        this.selectedVariants = [];
        this.selectedObj = [];
        const selectedOpt = this.selectedOptions.filter(element => element !== null);
        if(selectedOpt.length == this.selectedOptions.length){
          this.selectedColorNumber.map(obj => {
            this.variantData.variants.find(v => {
              if(v.options[0] == obj.color && v.options[1] == this.selectedOptions[1] && v.options[2] == this.selectedOptions[2]){
                v.selectedQuantity = obj.quantity;
                this.selectedVariants.push(v);
                this.selectedObj.push({
                  id: v.id,
                  quantity: obj.quantity
                });
              }
            });
          });
          if(this.selectedVariants.length > 0){
            this.appendLineItems();
          }
        }
      }

      updatePrice() {
        this.totalQuantity = this.calculateTotalQuantity();
        this.priceJson = this.getPriceJSON();
        this.priceContainers = this.section.querySelectorAll('.price-container');

        const basePrice = this.variantData.variants[0].compare_at_price > 0 ? this.variantData.variants[0].compare_at_price : this.variantData.variants[0].price; // price in cents
        const originalPrice = this.variantData.variants[0].price;
        const pricingTiers = [...this.priceJson.pricing].sort((a, b) => b.pack - a.pack); // Descending
        const sortedPricingTiers = [...this.priceJson.pricing].sort((a, b) => a.pack - b.pack); // Descending

        this.priceContainers.forEach(el => {
          const element = el.querySelector('.build-price');
          let remainingQty = this.totalQuantity;
          let newTotal = 0;

          // Apply discount tiers
          for (const tier of pricingTiers) {
            while (remainingQty >= tier.pack) {
              const packTotal = basePrice * tier.pack;
              const discountAmount = (packTotal * tier.discount) / 100;
              newTotal += packTotal - discountAmount;
              remainingQty -= tier.pack;
            }
          }

          // Remaining items without discount
          if (remainingQty > 0) {
            newTotal += originalPrice * remainingQty;
          }

          const compareAtTotal = basePrice * this.totalQuantity;
          const pricePer = newTotal / this.totalQuantity;
          const pricePerFormat = el.querySelector('.price-per--item').dataset.msg;
          let compareQty = 0;
          if(!this.validateQtyBuild){
            compareQty = 0;
          }

          if (this.totalQuantity > compareQty || newTotal < compareAtTotal) {
            /*if(getCookie("single_add_to_cart_flow") && getCookie("single_add_to_cart_flow") === 'true'){
              el.querySelector('.build-price').classList.remove('hidden');
              el.querySelector('.single-price').classList.add('hidden');
            }*/
            element.querySelector('.price__current').innerHTML = Shopify.formatMoney(newTotal, window.theme.settings.moneyWithoutCurrencyFormat);
            element.querySelector('.price__was').innerHTML = Shopify.formatMoney(compareAtTotal, window.theme.settings.moneyWithoutCurrencyFormat);
            element.querySelector('.price-per--item').innerHTML = pricePerFormat.replace('MONEY', Shopify.formatMoney(pricePer, window.theme.settings.moneyWithoutCurrencyFormat));

            const currentPrice = newTotal;
            const newDiscountedPrice = Shopify.formatMoney(currentPrice*20/100, window.theme.settings.moneyWithoutCurrencyFormat);
            if(this.section.querySelector(`.pack-product-membership-widget .product-member-price`)){
              this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = newDiscountedPrice;
            }
          } else {
            if(this.validateQtyBuild){
              // Reset to default
              ['.price__current', '.price__was', '.price-per--item'].forEach(selector => {
                const elDefault = element.querySelector(selector);
                elDefault.innerHTML = elDefault.dataset.default;
              });
              const totalPrice = basePrice - (basePrice*sortedPricingTiers[0].discount/100);
              const totalPackPrice = sortedPricingTiers[0].pack*totalPrice;
              const newDiscountedPrice = Shopify.formatMoney(totalPackPrice*20/100, window.theme.settings.moneyWithoutCurrencyFormat);
              if(this.section.querySelector(`.pack-product-membership-widget .product-member-price`)){
                this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = newDiscountedPrice;
              }
            }else{
              /*if(getCookie("single_add_to_cart_flow") && getCookie("single_add_to_cart_flow") === 'true'){
                el.querySelector('.build-price').classList.add('hidden');
                el.querySelector('.single-price').classList.remove('hidden');
              }*/
              element.querySelector('.price__current').innerHTML = Shopify.formatMoney(originalPrice, window.theme.settings.moneyWithoutCurrencyFormat);
              element.querySelector('.price__was').innerHTML = Shopify.formatMoney(basePrice, window.theme.settings.moneyWithoutCurrencyFormat);
              element.querySelector('.price-per--item').innerHTML = ``;
            }
          }
        });
      }

      getVariantData(){
        const dataEl = this.querySelector('[type="application/json"]');
        return JSON.parse(dataEl.textContent);
      }

      getPriceJSON(){
        const dataEl = this.querySelector('#build-pack-pricing[type="application/json"]');
        const priceJson = JSON.parse(dataEl.textContent);
        // Sort pricing tiers by pack number ascending
        priceJson.pricing.sort((a, b) => a.pack - b.pack);
        return priceJson;
      }

      appendLineItems(){
        if(!this.selectedVariants) return;
        
        if(this.selectedVariants.length == this.selectedObj.length && this.inValid == false){
          const uniqueId = Math.floor(new Date().valueOf() * Math.random());
          this.querySelector('.line-items [name="ids"]').value = JSON.stringify(this.selectedObj);
          this.productForm.querySelector('.pack-inputs').innerHTML = this.querySelector('.line-items').innerHTML;
        }
      }

      resetColorNumbers(){
        this.querySelectorAll('.custom-number_input').forEach(el => {
          const customSelect = el.closest('custom-select');
          customSelect.selectOption(customSelect.querySelectorAll('.custom-select__option')[0]);
        });
      }

      getSelectedColorNumbers(){
        const data = [];
        const allNumberInputs = this.querySelectorAll('.custom-number_input');
        if(allNumberInputs.length == 0){
          Array.from(this.querySelectorAll('.custom-number-selector-native')).forEach(el => {
            if(el.value > 0){
              data.push({
                color: el.dataset.option,
                quantity: el.value
              });
            }
          });
          return data;  
        }
        if(allNumberInputs.length == 1){
          this.inValid = false;
        }
        Array.from(this.querySelectorAll('.custom-number_input')).forEach(el => {
          if(el.value > 0){
            data.push({
              color: el.dataset.option,
              quantity: el.value
            });
          }
        });

        return data;
      }

      calculateTotalQuantity() {
        const total = Array.from(this.querySelectorAll('.custom-number_input'))
          .map(input => parseInt(input.value, 10))
          .filter(value => !isNaN(value))
          .reduce((sum, value) => sum + value, 0);
        this.colorCountContainer.innerText = total;
        return total;
      }

      udpateDiscountMessage(){
        this.totalQuantity = this.calculateTotalQuantity();
        this.priceJson = this.getPriceJSON();
        // console.log(this.priceJson);
        if(this.totalQuantity > 0){
          // Find the next pricing tier the user can reach
          const pricingTiers = this.priceJson.pricing;
          let nextTier = null;

          if(this.totalQuantity < pricingTiers[0].pack && this.validateQtyBuild){
            this.inValid = true;
          }else{
            this.inValid = false;
          }

          for (let i = 0; i < pricingTiers.length; i++) {
            if (this.totalQuantity < pricingTiers[i].pack) {
              nextTier = pricingTiers[i];
              break;
            }
          }
          // console.log(nextTier);

          let t = 0;

          for (let i = 0; i < pricingTiers.length; i++) {
            if (this.totalQuantity >= pricingTiers[i].pack) {
              t = pricingTiers[i];
            }
            if (this.totalQuantity < pricingTiers[i].pack) {
              nextTier = pricingTiers[i];
              break;
            }
          }

          if (nextTier) {
            let text = this.discountMessage.querySelector('.discount-info').dataset.addMoreMsg;
            text = text.replace('PACK', nextTier.pack - this.totalQuantity);
            text = text.replace('PERCENT', nextTier.display_discount);
            this.discountMessage.querySelector('.discount-info').textContent = text;
          } else {
            // User has reached or exceeded the last tier
            const lastTier = pricingTiers[pricingTiers.length - 1];
            this.discountMessage.querySelector('.discount-info').textContent = `Reached max discount of ${lastTier.display_discount}% Off`;
          }

          if(this.totalQuantity != t.pack && this.totalQuantity > 0){
            const totalDiscountPerQty = t.discount*this.variantData.variants[0].price/100;
            const totalAmount = this.variantData.variants[0].price*this.totalQuantity/100;
            const totalDiscount = totalDiscountPerQty*t.pack/100;
            // const finalDiscount = totalAmount - totalDiscount;
            const newPercentage = (totalDiscount / totalAmount)*100;
            // console.log(t, totalAmount, totalDiscount, finalDiscount, newPercentage);
            if(newPercentage > 0){
              t.display_discount = Math.round(newPercentage);
            }
          }

          /*if(getCookie("single_add_to_cart_flow") && getCookie("single_add_to_cart_flow") === 'true'){
            this.badges = this.section.querySelectorAll('.product-badge-container .off-badge-label');
            if(t != 0){
              this.badges.forEach(b => {
                const msg = b.dataset.msg;
                b.innerText = msg.replace('AMOUNT', t.display_discount);
                b.classList.remove('hidden');
              })
            }else{
              this.badges = this.section.querySelectorAll('.product-badge-container .off-badge-label');
              this.badges.forEach(b => {
                b.classList.add('hidden');
              })
            }
          }*/
        }else{
          this.discountMessage.querySelector('.discount-info').textContent = this.discountMessage.querySelector('.discount-info').dataset.selectMsg;
          this.inValid = true;
        }
      }
    }

    customElements.define('variant-picker-build', VariantPickerBuild);
  }
}

if (!customElements.get('variant-picker-curated')) {
  class VariantPickerCurated extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');

      this.mainVariantContainer = this.closest('variant-picker-bundle');
      this.variantData = this.getVariantData();
      this.packVariantsData = this.getPackVariantData();
      
      this.optionSelectors = this.querySelectorAll('.option-selector.option-default-selector:not(.option-selector--custom)');
      this.packOptionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom):not(.option-default-selector)');
      this.totalOptionSel = this.optionSelectors.length + this.packOptionSelectors.length;
      this.selectedOptions = this.getSelectedOptions();
      this.packSelectedOptions = this.getSelectedPackOptions();
      
      this.colorIndex = this.querySelector('[data-option="Color"]').dataset.optionIndex;

      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(evt){
      this.packSelectedOptions = this.getSelectedPackOptions();
      this.selectedOptions = this.getSelectedOptions();
      this.selectedPack = this.getSelectedPack();
      this.data = this.getVariantData();

      this.updateOptions();
      this.variants = this.getSelectedVariants();
      this.updatePrice();
      this.updateAddToCartButton();
      
      VariantPickerCurated.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:curated_variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variants: this.variants,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions,
          packSelectedOptions: this.packSelectedOptions,
          selectedPack: this.selectedPack
        }
      }));
    }

    getSelectedPackOptions(){
      const selectedOptions = [];

      this.packOptionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    getSelectedOptions(){
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    updateOptions(){
      if(this.selectedPack){
        this.selectedColors = this.selectedPack.option1.split(',');
        this.colorsExist = [];
        
        const hasDuplicates = arr => arr.filter((v, i) => arr.indexOf(v) !== i).length > 0;
        
        this.variantData.variants.forEach(v => {
          if(this.selectedColors.indexOf(v.options[this.colorIndex - 1]) != -1){ this.colorsExist.push(v.options[this.colorIndex - 1]); };
        });

        this.colorsExist = [... new Set(this.colorsExist)];
        this.isSoldout = false;

        if(hasDuplicates(this.selectedColors)){
          const newColorList = [];
          this.selectedColors.forEach(color => {
            if(this.colorsExist.indexOf(color) != -1){
              newColorList.push(color);
            }
          });
          this.colorsExist = newColorList;
        }
        
        if(this.colorsExist.length == this.selectedColors.length){
          this.disabledOption = this.variantData.variants.filter(v => {
            return this.selectedColors.indexOf(v.options[this.colorIndex - 1]) != -1 && v.available != true;
          });
          this.isSoldout = false;
        }else{
          this.isSoldout = true;
        }

        this.optionSelectors.forEach((selector, selectorIndex) => {
          if(this.isSoldout){
            selector.querySelectorAll('.opt-btn').forEach(input => {
              input.classList.add('is-unavailable');
            });
          }else{
            selector.querySelectorAll('.opt-btn').forEach(input => {
              input.classList.remove('is-unavailable');
            });
            // disabled only option which is soldout as per current selection
            // this.disabledOption
          }
        });

        const totalOptions = this.optionSelectors.length;
        const selectedOpt = this.selectedOptions.filter(o => o !== null).length;
        
        if(selectedOpt == totalOptions){
          this.selectedVariants == [];
          this.selectedVariants = this.selectedColors.map(color => {
            return this.variantData.variants.find(v => (v.options[this.colorIndex - 1] == color && v.option2 == this.selectedOptions[0] && v.option3 == this.selectedOptions[1] && v.available));
          });
          
          /*this.selectedVariants = this.variantData.variants.filter(v => {
            if(this.selectedColors.indexOf(v.options[this.colorIndex - 1]) != -1 && v.option2 == this.selectedOptions[0] && v.option3 == this.selectedOptions[1] && v.available){
              return v;
            }
          });*/
          this.appendLineItems();
        }
      }else{
        this.isSoldout = true;
        const selectedPackOpt = this.packSelectedOptions.filter(o => o !== null).length;
        
        if(selectedPackOpt == this.packOptionSelectors.length){
          this.optionSelectors.forEach((selector, selectorIndex) => {
            if(this.isSoldout){
              selector.querySelectorAll('.opt-btn').forEach(input => {
                input.classList.add('is-unavailable');
              });
            }else{
              selector.querySelectorAll('.opt-btn').forEach(input => {
                input.classList.remove('is-unavailable');
              });
              // disabled only option which is soldout as per current selection
              // this.disabledOption
            }
          });
        }
      }
    }

    appendLineItems(){
      if(!this.selectedVariants) return;
      
      if(this.selectedVariants.length == parseInt(this.selectedPack.option2)){
        const uniqueId = Math.floor(new Date().valueOf() * Math.random());

        // console.log(this.selectedPack.pack);
        this.querySelector('.line-items [name="properties[_bundle_tier]"]').value = this.selectedPack.pack;
        this.querySelector('.line-items [name="properties[_bundle_title]"]').value = `Curated ${this.selectedPack.option2} Pack`;
        this.querySelector('.line-items [name="properties[_bundle_number]"]').value = uniqueId;
        this.querySelector('.line-items [name="ids"]').value = this.selectedVariants.map(v => v.id).join(',');
        this.productForm.querySelector('.pack-inputs').innerHTML = this.querySelector('.line-items').innerHTML;
      }
    }

    updatePrice(){
      if(this.selectedPack && this.section.querySelector(`#price-${this.selectedPack.option2}-pack`)){
        this.section.querySelectorAll(`.curated-price .per-pack-price`).forEach(p => p.classList.add('hidden'));
        // this.section.querySelector(`#price-${this.selectedPack.option2}-pack`).classList.remove('hidden');
        this.section.querySelectorAll(`.price-${this.selectedPack.option2}-pack`).forEach(p => p.classList.remove('hidden'));
      }
    }

    updateAddToCartButton() {
      if (!this.productForm) return;
      
      if (this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      
      if(!this.selectedVariants){
        this.addBtn.classList.remove('is-error');
        if(this.addBtn.querySelector('.add-to-cart-text')){
          this.addBtn.querySelector('.add-to-cart-text').textContent = this.addBtn.dataset.addToCartText;
        }
        this.addBtn.textContent = this.addBtn.dataset.addToCartText;
        return;
      }

      const variantAvailable = this.selectedPack && this.selectedVariants.length == parseInt(this.selectedPack.option2) ? true : false;
      // console.log(variantAvailable, this.selectedVariants, this.selectedPack);
      this.addBtn.disabled = !variantAvailable;
      this.addBtn.classList.remove('is-error');

      if(this.addBtn.querySelector('.add-to-cart-text')){
        this.addBtn.querySelector('.add-to-cart-text').textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
        return;
      }
      
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    getSelectedVariants(){
      
    }

    getSelectedPack(){
      return this.packVariantsData.variants.find(f => {
        return f.option1 == this.packSelectedOptions[0] && f.option2 == this.packSelectedOptions[1];
      });
    }

    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const otherOption = selector.querySelector('.js-option-text');

      if(otherOption){
        otherOption.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      }

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    getPackVariantData(){
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    getVariantData() {
      const dataEl = this.mainVariantContainer.querySelector('variant-picker [type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('variant-picker-curated', VariantPickerCurated)
}

if (!customElements.get('variant-picker-bundle')) {
  class VariantPickerBundle extends HTMLElement{
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.packInputContainer = this.productForm.querySelector('.pack-inputs');
      this.packTypeInput = this.productForm.querySelector('[name="__pack-type"]');

      this.buildDiscountContainer = this.productForm.querySelector('.build-pack-discount-container');
      this.currentURL = this.getURLParams();
      this.selectBundleTab();

      // this.data = this.getVariantData();
      this.querySelector('.tab-list').querySelectorAll('.tab-link').forEach(btn => {
        btn.addEventListener('click', (evt) => {
          this.currentTab = evt.target.dataset.for;
          this.updateCurrentTab();
          this.packTypeInput.value = this.currentTab;
          this.packInputContainer.innerHTML = '';
          if(this.currentTab == 'build'){
            this.querySelector('variant-picker-build').appendLineItems();
            this.querySelector('variant-picker-build').handleOptionBtnVisibility();
          }else if(this.currentTab == 'curated'){
            this.querySelector('variant-picker-curated').appendLineItems();
          }
        });
      });
      this.runABTest();
    }

    runABTest(){
      /*if(getCookie("single_add_to_cart_flow") && getCookie("single_add_to_cart_flow") === 'true'){
        this.section.querySelector('.tabs-container').classList.add('hidden');
        if(this.querySelector('[data-for="build"]')) this.querySelector('[data-for="build"]').dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
        this.currentTab = 'build';
        this.updateCurrentTab();
        this.updateTitle(false);
        this.classList.add('hide-tabs');
        this.section.querySelector('variant-picker-build').validateQtyBuild = false;
        if(this.section.querySelector('variant-picker-build [data-option="Color"]')){
          const colorLength = this.section.querySelector('variant-picker-build [data-option="Color"]').dataset.optionLength;
          if(colorLength == 1){
            const colorWrapper = this.section.querySelector('variant-picker-build [data-option="Color"] .option-selector__btns');
            colorWrapper.querySelector('custom-select').selectOption(colorWrapper.querySelector('custom-select [data-value="1"]'));
            this.section.querySelector('.quantity-wrapper').classList.remove('hidden');
          }
        }
      }else{
        if(this.section.querySelector('.quantity-wrapper') != undefined){
          this.section.querySelector('.quantity-wrapper').remove();
        }
      }*/
    }
    
    getVariantData() {
      const dataEl = this.querySelector('variant-picker [type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    updateCurrentTab(){
      if (this.currentTab != 'build'){
        this.buildDiscountContainer.classList.add('hidden');
      }else{
        this.buildDiscountContainer.classList.remove('hidden');
      }

      if(this.section.querySelector('.inventory-msg')){
        if(this.currentTab == 'curated' || this.currentTab == 'build'){
          this.section.querySelector('.inventory-msg').classList.add('hidden');
        }else{
          this.section.querySelector('.inventory-msg').classList.remove('hidden');
        }
      }

      if(this.section.querySelectorAll(`.product-membership-widget`).length > 0){
        this.section.querySelectorAll(`.product-membership-widget`).forEach(p => p.classList.add('hidden'));
        if(this.currentTab == 'single'){
          if(this.section.querySelector(`.single-product-membership-widget`)){
            this.section.querySelector(`.single-product-membership-widget`).classList.remove('hidden');
          }
        }else{
          if(this.section.querySelector(`.pack-product-membership-widget`)){
            this.section.querySelector(`.pack-product-membership-widget`).classList.remove('hidden');
          }
        }
      }
      
      this.updateUrl();
      this.updateAddToCart();
      this.updatePrice();
      this.updateGallery();
      this.updateTitle(true);
    }
    
    selectBundleTab() {
      let tab = 'single';

      this.url = this.dataset.url;
      if(this.url.indexOf('pack') != -1){
        // tab = 'build';
        if(this.url.indexOf('curated') != -1 && this.querySelector('[data-for="curated"]') != null){
          tab = 'curated';
        } else if(this.querySelector('[data-for="build"]') != null){
          tab = 'build';
        }
      }
      if (this.currentURL.params && this.currentURL.params['pack-name']) {
        tab = this.currentURL.params['pack-name'];
      }
      this.currentTab = tab;
      this.packTypeInput.value = this.currentTab;
      this.packInputContainer.innerHTML = '';
      switch (tab) {
        case 'build':
          if(this.querySelector('[data-for="build"]')) this.querySelector('[data-for="build"]').dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
          break;
        case 'curated':
          if(this.querySelector('[data-for="curated"]')) this.querySelector('[data-for="curated"]').dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
          break;
        default:
          if(this.querySelector('[data-for="single"]')) this.querySelector('[data-for="single"]').dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
          break;
      }
      this.updateCurrentTab();
    }

    /*updateUrl(evt){
      if(!this.currentURL){
        this.currentURL = window.location.href;
      }
      const currentURL = window.location.href;
      const isSameURL = this.currentURL.url.indexOf(this.dataset.url) != -1 ? true : false;
      const hasPackParam = this.currentURL.params.hasOwnProperty("pack-name") ? true : false;

      let url = this.dataset.url;
      const hasOtherParams = this.currentURL.params;
      let concat = '&';
      let otherParams = [];
      let otherParamsLink = ``;
      // Check if there are any key-value pairs in hasOtherParams
      let hasParams = hasOtherParams && Object.keys(hasOtherParams).length > 0;
      if(this.currentURL.params.hasOwnProperty("_psq")){
        hasParams = false;
      }
      if(!hasParams || hasPackParam){
        concat = '?';
      }else{
        if(hasPackParam){
          for (const [key, value] of Object.entries(hasOtherParams)) {
            if (key !== "pack-name") {
              otherParams.push(`${key}=${value}`);
            }
          }
        }
      }
      otherParams.push(`pack-name=${this.currentTab}`);
      otherParamsLink = otherParams.join('&');
      // console.log(otherParamsLink, otherParams, concat);
      if(isSameURL){
        url = `${this.dataset.url}${concat}${otherParamsLink}`;
      }else{
        if(hasPackParam){
          url = `${this.currentURL.url.split('?')[0]}${concat}${otherParamsLink}`;
        }else{
          url = `${this.currentURL.url}${concat}${otherParamsLink}`;
        }
      }
      window.history.replaceState({ }, '', url);
    }*/

    updateUrl(evt) {
      const urlObj = new URL(window.location.href);
      const params = urlObj.searchParams;

      const newPackName = this.currentTab;

      if (newPackName) {
        // If pack-name exists → update it, else → add it
        params.set('pack-name', newPackName);
      } else {
        // If no value → remove it (fallback case)
        params.delete('pack-name');
      }

      // If only one param exists → URL will automatically use '?'
      // No need to manually handle ? or &
      urlObj.search = params.toString();

      window.history.replaceState({}, '', urlObj.toString());
    }

    getURLParams() {
      const url = window.location.href;
      const params = {};
      const searchParams = new URLSearchParams(window.location.search);
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }
      return { url, params };
    }

    updateFormState(){
      
    }

    updateGallery(){
      this.section.querySelector('media-gallery').currentMediaGroup = null;
      let containerElement = this.querySelector('variant-picker');
      if(this.currentTab == 'curated'){
        containerElement = this.querySelector('variant-picker-curated');
      }else if(this.currentTab == 'build'){
        containerElement = this.querySelector('variant-picker-build');
      }
      setTimeout(() => {
        let colorElement = containerElement.querySelector('.option-selector[data-option="Color"]');
        const selectedColor = !colorElement.querySelector('[type="radio"]:checked') ? colorElement.querySelectorAll('[type="radio"]')[0].value : colorElement.querySelector('[type="radio"]:checked').value;
        const colorEl = colorElement.querySelector(`[value="${selectedColor}"]`)
        colorEl.checked = true;
        colorEl.dispatchEvent(new Event('change', { bubbles: true }));
      }, 10);
    }

    updateTitle(update = false){
      this.titleContainer = this.section.querySelectorAll('.product-title');
      this.titleContainer.forEach(el => {
        if(update == true){
          el.innerText = `${!this.querySelector('.product-bundle-tabs .tab-link.active') ? this.querySelector('.product-bundle-tabs .tab-link[data-for="single"]').dataset.title : this.querySelector('.product-bundle-tabs .tab-link.active').dataset.title} - ${this.dataset.title}`
        }else{
          el.innerText = this.dataset.title;
        }
      })
    }

    updatePrice(){
      this.priceContainer = this.section.querySelectorAll('.price-container');
      this.priceContainer.forEach(el => {
        el.querySelectorAll('.product-info__price > div').forEach(d => {
          if(d.classList.contains(`${this.currentTab}-price`)){
            d.classList.remove('hidden');
          }else{
            d.classList.add('hidden');
          }
        });
      })
    }
    
    updateAddToCart(){
      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');

      this.addBtn.disabled = false;
      this.addBtn.classList.remove('is-error');

      if(this.addBtn.querySelector('.add-to-cart-text')){
        this.addBtn.querySelector('.add-to-cart-text').textContent = this.addBtn.dataset.addToCartText;
        return;
      }
      
      this.addBtn.textContent = this.addBtn.dataset.addToCartText;
    }
  }

  customElements.define('variant-picker-bundle', VariantPickerBundle);
}

if (!customElements.get('back-in-stock')) {
  class BackInStock extends HTMLElement{
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.bisForm = this.querySelector('.notify-bis-form');
      this.errorContainer = this.querySelector('.bis-error');

      this.bisForm.addEventListener('submit', this.handleSubmit.bind(this));
    }

    handleSubmit(evt){
      evt.preventDefault();

      const formValid = this.validate();
    
      if (!formValid) return;

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": this.querySelector('.custom-option__text-input-email').value,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::"+this.productForm.querySelector('[name="id"]').value
              }
            }
          }
        }
      }

      var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2025-10-15"
          },
          body: JSON.stringify(payload),
      };

      const res = fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=PjKgix",requestOptions)
          .then(result => console.log(result))
          .catch(error => console.log('error', error));

      // console.log(res);
      if(res.errors){
        this.errorContainer.innerHTML = `<p>${res.errors[0].detail}</p>`;
      }else{
        const payload = {
          "data": {
            "type": "subscription",
            "attributes": {
              "custom_source":"form",
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": this.querySelector('.custom-option__text-input-email').value,
                  },
                },
              },
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": "NqCekM"
                }
              }
            }
          }
        }

        var requestOptions = {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "revision":"2025-10-15"
            },
            body: JSON.stringify(payload),
        };

        const res = fetch("https://a.klaviyo.com/client/subscriptions/?company_id=PjKgix",requestOptions)
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

        if(res.errors){

        }else{
          this.bisForm.reset();
          this.querySelector('.success-msg').innerHTML = `<p>You're in! We'll let you know when it's back</p>`;
        }
      }
    }

    validate(){
      let isValid = true;
      this.errorContainer.innerHTML = '';
      const emailValue = this.querySelector('.custom-option__text-input-email');
      if(emailValue.value == '' || emailValue.value == undefined){
        // this.errorContainer.innerHTML = `<p>Please enter a valid email address.</p>`;
        emailValue.placeholder = 'Please enter a valid email address.';
        emailValue.classList.add('error');
        isValid = false;
      }else{
        emailValue.placeholder = 'Email Address';
        emailValue.classList.remove('error');
      }
      if(this.querySelector('.custom-option__text-input-terms-agree').checked){
        this.errorContainer.innerHTML = '';
      }else{
        this.errorContainer.innerHTML = `<p>Please select terms conditions</p>`;
        isValid = false;
      }

      return isValid;
    }
  }

  customElements.define('back-in-stock', BackInStock);
}